import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { setFilialEdit, fetchCities, fetchFilial, updateFilial, removeUserPoint } from '../../action/handbook';
import cn from 'classnames';
import Loader from '../utils/Loader';
import { cloneDeep, isEqual } from 'lodash';
import ErrorContainer from '../utils/ErrorContainer';
import { YMaps, Map, SearchControl, Placemark } from 'react-yandex-maps';
import { createSelector } from 'reselect'
import Select from 'react-select';
import { fetchGoods, fetchCategories } from '../../action/goods';
import { fetchKassaAccounts } from '../../action/yookassa';
import Switch from '../utils/Switch';
import { daysWeek, optionsMinDeliveryTime, optionsMinSamTime, optionsSno, optionsVat, roleId, timeDelivery } from '../../constants/app'
import { setUIvisible } from '../../action/UImobile';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

const activateSelect = {
    'active': 'Активирован',
    'disabledAll': 'Полностью остановлен',
    'disabledDelivery': 'Доставка остановлена',
    'disabledOwn': 'Самовывоз остановлен',
};

/*const activateYESelect = {
    'active': 'Активирован',
    'disbledDDC': 'Доставка сервиса остановлена',
    'disabledMarketplace': 'Доставка ресторана остановлена',
    'disabled': 'Полностью остановлен',
};*/

const activateKuperSelect = {
    'ACTIVE': 'Активирован',
    'INACTIVE': 'Временно недоступен для заказов',
    'DISCONNECTED': 'Отключен от системы СберМаркет',
};

class EditFilial extends Component {
    async componentDidMount() {
        this.props.fetchCities();
        this.props.fetchKassaAccounts();
        this.props.fetchFilial(this.props.match.params.id).then(result => {
            this.props.setFilialEdit(cloneDeep(result));
        });
        this.props.fetchGoods();
        this.props.fetchCategories();
        this.props.setUIvisible(false ,false);
    }

    componentWillUnmount() {
        this.props.setFilialEdit(null);
    }
    
    renderSubHeader() {
        const { state } = this.props.location;
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Редактирование филиала</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                            
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push(state && state.city && state.from === 'edit' ? `/handbook/cities/edit/${state.city}` : '/handbook/filials' )} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidAtolData() {
        const { inn, atolData } = this.props.edit;
        if (!atolData || !atolData.activate) return true;
        if (atolData.sno && atolData.vat && inn) return true;
        return false;
    }

    isValidFilial() {
        const { city, street, house, email, phone, timeWork, coord, minDeliveryTime, minSamTime } = this.props.edit;
        if (isEqual(this.props.detail, this.props.edit)) return false;

        if (!city 
            || !street 
            || !house 
            || !email 
            || !phone 
            || !timeWork 
            || !coord 
            || !minDeliveryTime 
            || !minSamTime
            || !this.isValidAtolData()
        ) return false;

        return true;
    }

    setCity = (field) => (e) => {
        const data = {...this.props.edit};

        if (field === 'stopList') data.changeStopList = true;
        if (field === 'activateYE' || field === 'integration') data.changeActivateYE = true;
        if (field === 'activateKuper' || field === 'integrationKuper') data.changeActivateKuper = true;
        if (field === 'minSamTime') data.changeTime = true;
        
        if (field === 'minDeliveryTime' || field === 'minSamTime') {
            data[field] = e.value;
        }

        if(field === 'hiddenClient') {
            data.minDeliveryTime = timeDelivery.minDeliveryTime
            data.minSamTime = timeDelivery.minSamTime
            data.activate = 'disabledAll'
        }        

        if(field === 'promotion' && e === false)
            data.promotionDescription = null

        if (field === 'integration') {
            if (e === false) {
                data.activateYE = 'disabled';
            } else {
                data.activateYE = 'active';
            }
        }

        if (field === 'integrationKuper') {
            if (e === false) {
                data.activateKuper = 'DISCONNECTED'
            } else {
                data.activateKuper = 'ACTIVE'
            }
        }

        if (field === 'stopList') data.changeStopList = true;
        
        if (field === 'onlinePay' 
            || field === 'stopList' 
            || field === 'stop' 
            || field === 'directOrder' 
            || field === 'disableLoyalSystem' 
            || field === 'onlineDirectOrder' 
            || field === 'isRobovoiceEnable'
            || field === 'isEnableFrontpadForPoint'
            || field === 'hiddenClient'
            || field === 'qrPayment'
            || field === 'deliveryToTheEntrance'
            || field === 'cafe'
            || field === 'promotion'
            || field === 'integration'
            || field === 'integrationKuper'
            || field === 'enableConsumption') {
            data[field] = e;
        } else if (field !== 'minDeliveryTime' && field !== 'minSamTime') {
            data[field] = e.target.value;
        }
        this.props.setFilialEdit(data);
    }

    setAtol = (field) => (e) => {
        const data = {...this.props.edit};
        const dataAtol = {...data.atolData} || {};

        if (field === 'activate') {
            dataAtol[field] = e;
        } else {
            if(field === 'sno' || field === 'vat') {
                dataAtol[field] = e.value;
            } else {
                dataAtol[field] = e.target.value;
            }
        }

        data.atolData = dataAtol;
        this.props.setFilialEdit(data);
    }

    setFields = (fields) => {
        const data = {...this.props.edit};

        for (let field in fields) {
            data[field] = fields[field];
        }

        this.props.setFilialEdit(data);
    }


    setOnlinePay = (value) => {
        if(value) {
            this.setCity('onlinePay')(value);
        } else {
            const fields = {
                onlinePay: value,
                onlineDirectOrder: value
            }
            this.setFields(fields);
        }
    }

    setDirectOrder = (value) => {
        if(value && this.props.edit.disableLoyalSystem) {
            const fields = {
                directOrder: value,
                disableLoyalSystem: !value
            }
            this.setFields(fields)
        } else {
            this.setCity('directOrder')(value)
        }
    }

    setDisableLoyalSystem = (value) => {
        if(value && this.props.edit.directOrder) {
            const fields = {
                directOrder: !value,
                disableLoyalSystem: value
            }
            this.setFields(fields)
        } else {
            
            this.setCity('disableLoyalSystem')(value)
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        const data = { ...this.props.edit };
        delete data.users;
        
        data.user = this.props.user.name ? this.props.user.name : this.props.user.username;

        this.props.updateFilial(this.props.match.params.id, data).then(result => {
            if (result) {
                this.props.history.push('/handbook/filials');
            }
        });
    }

    handleRemoveUserPoints = (e) => {
        e.preventDefault();
        this.props.removeUserPoint(this.props.edit.id).then(result => {
            if (result) {
                this.props.history.push(`/handbook/filials`)
            }
        });
    }

    onResultShow = () => {
        if (this.map) {
            const index = this.map.getSelectedIndex();
            const result = this.map.getResultsArray();
            const coord = result[index].geometry.getCoordinates().join(',');
            this.setCoord(coord);
          }
    };

    setCoord = (value) => {
        const data = {...this.props.edit};
        data['coord'] = value;
        this.props.setFilialEdit(data);
    }

    checkTimetableWork = (field, item) => {
        if(item && item[field]) {
            return item[field];
        } else {
            if(field === 'startOwn' || field === 'startDelivery') return '10:00';
            if(field === 'endOwn') return '22:55';
            if(field === 'endDelivery') return '22:45';
        }
    }

    getTimetableArray = (timetableWork) => {
        if (!timetableWork) return [{}];
        if (Array.isArray(timetableWork)) return timetableWork;
        return [timetableWork];
    }

    onChangeActiveOnWeekDays = (item, index, value) => {
        const data = {...this.props.edit};

        const { timetableWork } = data;
        const timetableArray = this.getTimetableArray(timetableWork);

        const updated = item || {};
        updated.days = updated.days ? updated.days : [];
        if (updated.days.includes(value)) {
            updated.days = updated.days.filter((day) => day !== value);
        } else {
            updated.days.push(value);
        }

        timetableArray[index] = updated;
        data.timetableWork = timetableArray;
        this.props.setFilialEdit(data);
    }

    disabledCheckboxDay = (day, index, timetableArray) => {
        const result = timetableArray.find((item, itemIndex) => item.days ? item.days.includes(day) && itemIndex !== index : null);
        if (result) return true;
        return false;        
    }

    setTimetableWork = (field, item, index) => (e) => {
        const data = {...this.props.edit};

        const { timetableWork } = data;
        const timetableArray = this.getTimetableArray(timetableWork);

        const updated = item || {};
        updated[field] = e.target.value;
        timetableArray[index] = updated;
        data.timetableWork = timetableArray;
        this.props.setFilialEdit(data);
    }

    addTimetable = () => {
        const data = {...this.props.edit,};
        const { timetableWork } = data;
        const timetableArray = this.getTimetableArray(timetableWork);
        timetableArray.push({});
        data.timetableWork = timetableArray;
        this.props.setFilialEdit(data);
    }

    deleteTimeTable = (index) => {
        const data = {...this.props.edit};
        const { timetableWork } = data;
        const timetableArray = this.getTimetableArray(timetableWork);

        data.timetableWork = timetableArray.filter((item, itemIndex) => itemIndex !== index);
        this.props.setFilialEdit(data);
    }

    renderOnlinePayment = () => {
        const { user, edit } = this.props;
        if (![roleId.admin].includes(user.role.id)) return null;
        
        return (
            <div className='online-pay_block'>
                 <div className="row">
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="col-10 col-form-label">Онлайн-оплата</label>
                                <div className="col-2">
                                    <Switch 
                                        onChange={(value) => this.setOnlinePay(value)} 
                                        checked={edit.onlinePay} 
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="col-10 col-form-label">Прямой заказ онлайн</label>
                                <div className="col-2">
                                    <Switch 
                                        onChange={this.setCity('onlineDirectOrder')}
                                        checked={edit.onlineDirectOrder}
                                        disabled={!edit.onlinePay}
                                    />
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="ФИО ИП"
                            onChange={this.setCity('legalName')}
                            value={edit.legalName}
                            placeholder="ФИО ИП..."
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            required={true}
                            label="ИНН"
                            onChange={this.setCity('inn')}
                            value={edit.inn}
                            placeholder="ИНН..."
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="ОГРНИП"
                            onChange={this.setCity('ogrnip')}
                            value={edit.ogrnip}
                            placeholder="ОГРНИП..."
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8">
                        <Input
                            label="Почтовый адрес"
                            onChange={this.setCity('legalAdress')}
                            value={edit.legalAdress}
                            placeholder="Почтовый адрес..."
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Аккаунт Юкассы</label>
                            <select value={edit && edit.yookassa} onChange={this.setCity('yookassa')} className="form-control">
                                <option value="">Выберите аккаунт</option>
                                {
                                    this.props.kassaAccounts.map((item, index) => (
                                        <option key={index} value={item.id}>{item.name} - {item.secret}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="SHOP_ID"
                            onChange={this.setCity('shopId')}
                            value={edit.shopId}
                            placeholder="SHOP_ID..."
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderAtol = () => {
        const { user, edit } = this.props;
        if (![roleId.admin].includes(user.role.id)) return null;
        
        return (
            <div className='online-pay_block'>
                <h5> АТОЛ Web Request </h5>
                <div className="row">
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="col-10 col-form-label">Атол подключен</label>
                                <div className="col-2">
                                    <Switch 
                                        onChange={this.setAtol('activate')} 
                                        checked={edit.atolData ? edit.atolData.activate : false} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className='form-group'>
                            <label>НДС *</label>
                            <Select
                                menuPortalTarget={document.body}
                                closeMenuOnSelect={true}
                                options={optionsVat}
                                onChange={this.setAtol('vat')}
                                value={edit.atolData ? optionsVat.find((option) => option.value === edit.atolData.vat) : null}
                                placeholder="НДС..."
                        />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className='form-group'>
                            <label>Система налогообложения *</label>
                            <Select
                                menuPortalTarget={document.body}
                                closeMenuOnSelect={true}
                                options={optionsSno}
                                onChange={this.setAtol('sno')}
                                value={edit.atolData ? optionsSno.find((option) => option.value === edit.atolData.sno) : null}
                                placeholder="Система налогообложения..."
                            />
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <Input
                            label="Текст для печати на фискальном чеке"
                            onChange={this.setCity('fiscalText')}
                            value={edit.fiscalText}
                            placeholder="Текст для печати на фискальном чеке..."
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { edit } = this.props;        
        
        if (this.props.loading || this.props.cities.length === 0 || !edit) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }

        const { timetableWork } = edit;
        const timetableArray = this.getTimetableArray(timetableWork);
            
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    
                <div className="kt-portlet">
                    <form onSubmit={this.onSubmit} className="kt-form">
                        <div className="kt-portlet__body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Город *</label>
                                        <select disabled={true} value={edit.city.id} onChange={this.setCity('city')} className="form-control">
                                            <option value="">Выберите город</option>
                                            {
                                                this.props.cities.map((item, index) => (
                                                    <option key={index} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                {[roleId.admin].includes(this.props.user.role.id) && 
                                <div className="col-md-4">
                                    <Input
                                        label="Frontpad ID"
                                        onChange={this.setCity('frontpadId')}
                                        value={edit.frontpadId}
                                        placeholder="ID..."
                                    />
                                </div>
                                }
                                {[roleId.admin].includes(this.props.user.role.id) && 
                                <div className="col-md-4">
                                    {/*
                                    <div className="form-group row" style={{ marginTop: '25px' }}>
                                        <label className="col-4 col-form-label">Выключен</label>
                                        <div className="col-8" style={{ textAlign: 'right' }}>
                                            <Switch onChange={(value) => this.setCity('stop')(value)} checked={this.props.edit.stop}/>
                                        </div>
                                    </div>*/}
                                    <Input
                                        required={true}
                                        label="Время работы (инф.)"
                                        onChange={this.setCity('timeWork')}
                                        value={edit.timeWork}
                                        placeholder="Время работы..."
                                    />
                                </div>
                                }
                            </div>
                            {[roleId.admin].includes(this.props.user.role.id) && 
                                <div className='online-pay_block'>
                                    <label>График работы</label>
                                    {timetableArray.map((item, index) => (
                                    <div className='form-group'>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <Input
                                                    disableGroup={true}
                                                    label="Доставка с"
                                                    required={true}
                                                    type='time'
                                                    onChange={this.setTimetableWork('startDelivery', item, index)}
                                                    value={this.checkTimetableWork('startDelivery', item)}
                                                    placeholder="Доставка с"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <Input
                                                    disableGroup={true}
                                                    label="Доставка до"
                                                    required={true}
                                                    type='time'
                                                    onChange={this.setTimetableWork('endDelivery', item, index)}
                                                    value={this.checkTimetableWork('endDelivery', item)}
                                                    placeholder="Доставка до"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <Input
                                                    disableGroup={true}
                                                    label="Самовывоз с"
                                                    required={true}
                                                    type='time'
                                                    onChange={this.setTimetableWork('startOwn', item, index)}
                                                    value={this.checkTimetableWork('startOwn', item)}
                                                    placeholder="Самовывоз с"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <Input
                                                    disableGroup={true}
                                                    label="Самовывоз до"
                                                    required={true}
                                                    type='time'
                                                    onChange={this.setTimetableWork('endOwn', item, index)}
                                                    value={this.checkTimetableWork('endOwn', item)}
                                                    placeholder="Самовывоз до"
                                                />
                                            </div>
                                        </div>
                                        {timetableArray.length > 1 &&
                                        <div className="form-group">
                                            <label className="col-form-label">Дни недели</label>
                                            <div className='row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div className='kt-checkbox-inline' style={{ paddingLeft: '10px'}}>
                                                    {daysWeek.map((day) => (
                                                        <label className="kt-checkbox">
                                                            <input type="checkbox" disabled={this.disabledCheckboxDay(day.value, index, timetableArray)} checked={item.days ? item.days.includes(day.value) : false} onChange={() => this.onChangeActiveOnWeekDays(item, index, day.value)}/>
                                                            {day.label}
                                                            <span></span>
                                                        </label>
                                                    ))}
                                                </div>
                                                <button type='button' className='btn btn-sm btn-icon btn-danger' style={{ marginRight: '10px' }} onClick={() => this.deleteTimeTable(index)}> <i className='flaticon2-trash' /></button>
                                            </div>
                                        </div>
                                        }
                                        {timetableArray.length > 1 && <div className="kt-separator kt-separator--dark"/>}
                                    </div>
                                    ))}
                                    {timetableArray.length < 7 && 
                                    <div className="form-group row" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                        <button type='button' className='btn btn-icon btn-primary' style={{ width: '10rem' }} onClick={this.addTimetable}> <i className='flaticon2-plus' /></button>
                                    </div>
                                    }
                                </div>
                            }
                            {[roleId.admin].includes(this.props.user.role.id) && 
                            <div className="row">
                                <div className="col-md-4">
                                    <Input
                                        label="Улица"
                                        required={true}
                                        onChange={this.setCity('street')}
                                        value={this.props.edit.street}
                                        placeholder="Улица..."
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Input
                                        label="Дом"
                                        required={true}
                                        onChange={this.setCity('house')}
                                        value={this.props.edit.house}
                                        placeholder="Дом..."
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Input
                                        label="Подъезд"
                                        onChange={this.setCity('entrance')}
                                        value={this.props.edit.entrance}
                                        placeholder="Подъезд..."
                                    />
                                </div>
                            </div>
                            }
                            {[roleId.admin].includes(this.props.user.role.id) && 
                            <div className="row">
                                <div className="col-md-4">
                                    <Input
                                        label="Квартира / офис"
                                        onChange={this.setCity('room')}
                                        value={this.props.edit.room}
                                        placeholder="Квартира..."
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Input
                                        required={true}
                                        label="Email"
                                        onChange={this.setCity('email')}
                                        value={this.props.edit.email}
                                        placeholder="Email..."
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Input
                                        required={true}
                                        label="Телефон"
                                        onChange={this.setCity('phone')}
                                        value={this.props.edit.phone}
                                        placeholder="Телефон..."
                                    />
                                </div>
                            </div>
                            }
                            <div className="row">
                                {[roleId.admin].includes(this.props.user.role.id) && <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group row">
                                                <label className="col-12 col-form-label">Интеграция ЯЕ</label>
                                                <div className="col-12">
                                                    <Switch onChange={this.setCity('integration')} checked={this.props.edit.integration}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {/*<div className="col-md-4"> Пока нет доступа к push модели point.activateYE не используется
                                    <div className="form-group row">
                                        <label className="col-12 col-form-label">Доступность в ЯЕ</label>
                                        <div className="col-12">
                                            <select disabled={this.props.edit.hiddenClient || !this.props.edit.integration} onChange={(e) => this.setCity('activateYE')(e)} value={this.props.edit.activateYE} className="form-control">
                                                {
                                                    Object.keys(activateYESelect).map((key, index) => (
                                                        <option key={key} value={key}>{activateYESelect[key]}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>*/}
                            </div>
                            <div className="row">
                                {[roleId.admin].includes(this.props.user.role.id) && <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-12 col-form-label">Интеграция Купер</label>
                                        <div className="col-12">
                                            <Switch onChange={this.setCity('integrationKuper')} checked={this.props.edit.integrationKuper}/>
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-12 col-form-label">Доступность в Купер</label>
                                        <div className="col-12">
                                            <select disabled={this.props.edit.hiddenClient || !this.props.edit.integrationKuper} onChange={(e) => this.setCity('activateKuper')(e)} value={this.props.edit.activateKuper} className="form-control">
                                                {
                                                    Object.keys(activateKuperSelect).filter((item) => {
                                                        if ([roleId.admin].includes(this.props.user.role.id)) return true;
                                                        if (item.value === 'DISCONNECTED') return false;
                                                        return true;
                                                    })
                                                    .map((key, index) => (
                                                        <option key={key} value={key}>{activateKuperSelect[key]}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {this.props.edit.changeActivateKuper && <div className="col-md-4">
                                    <div className='form-group row'>
                                        <labe className="col-12 col-form-label">Коментарий к изменению доступности Купер</labe>
                                        <input
                                        type='text'
                                        className='form-control'
                                        autoComplete='false'
                                        placeholder='Комментарий'
                                        maxLength={30}
                                        defaultValue={this.props.edit.commentKuper}
                                        onChange={this.setCity('commentKuper')}
                                        />
                                    </div>
                                </div>}
                            </div>
                            <div className="row">
                                {[roleId.admin].includes(this.props.user.role.id) && <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group row">
                                                <label className="col-12 col-form-label">Списание сырья</label>
                                                <div className="col-12">
                                                    <Switch onChange={this.setCity('enableConsumption')} checked={this.props.edit.enableConsumption}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            {this.renderOnlinePayment()}
                            {this.renderAtol()}
                            <div className="row">
                                <div className="col-md-4">
                                    <label>{"Минимальное время доставки *"}</label>
                                    <Select
                                        isDisabled={this.props.edit.activate === 'disabledAll' || this.props.edit.activate === 'disabledDelivery' || this.props.edit.hiddenClient}
                                        menuPortalTarget={document.body}
                                        closeMenuOnSelect={true}
                                        options={optionsMinDeliveryTime}
                                        onChange={this.setCity('minDeliveryTime')}
                                        value={{value: this.props.edit.minDeliveryTime, label: this.props.edit.minDeliveryTime}}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>{"Минимальное время самовывоза *"}</label>
                                    <Select
                                        isDisabled={this.props.edit.activate === 'disabledAll' || this.props.edit.activate === 'disabledOwn' || this.props.edit.hiddenClient}
                                        menuPortalTarget={document.body}
                                        closeMenuOnSelect={true}
                                        options={optionsMinSamTime}
                                        onChange={this.setCity('minSamTime')}
                                        value={{value: this.props.edit.minSamTime, label: this.props.edit.minSamTime}}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Стоп лист товаров</label>
                                        <Select
                                            isLoading={this.props.loadingGoods}
                                            isDisabled={this.props.loadingGoods}
                                            menuPortalTarget={document.body}
                                            isMulti
                                            isSearchable
                                            closeMenuOnSelect={true}
                                            options={this.props.goods}
                                            placeholder="Товары"
                                            noOptionsMessage={() => 'Нет товаров'}
                                            onChange={this.setCity('stopList')}
                                            value={this.props.edit.stopList}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-12 col-form-label">Доступность</label>
                                        <div className="col-12">
                                            <select disabled={this.props.edit.hiddenClient} onChange={(e) => this.setCity('activate')(e)} value={this.props.edit.activate} className="form-control">
                                                {
                                                    Object.keys(activateSelect).map((key, index) => (
                                                        <option key={key} value={key}>{activateSelect[key]}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {[roleId.admin].includes(this.props.user.role.id) &&
                                <>
                                    <div className="col-md-4">
                                        <div className="form-group row">
                                            <label className="col-12 col-form-label">Прямой заказ</label>
                                            <div className="col-12">
                                                <Switch onChange={(value) => this.setDirectOrder(value)} checked={this.props.edit.directOrder} />
                                            </div>
                                        </div>                                    
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group row">
                                            <label className="col-12 col-form-label">Игнорировать систему лояльности</label>
                                            <div className="col-12">
                                                <Switch onChange={(value) => this.setDisableLoyalSystem(value)} checked={this.props.edit.disableLoyalSystem} />
                                            </div>
                                        </div>
                                    </div>                                
                                    <div className="col-md-4">
                                        <div className="form-group row">
                                            <label className="col-12 col-form-label">Скрыт для клиентов</label>
                                            <div className="col-12">
                                                <Switch onChange={this.setCity('hiddenClient')} checked={this.props.edit.hiddenClient} />
                                            </div>
                                        </div>
                                    </div>
                                </>
                                }
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-12 col-form-label">Есть оплата QR-кодом</label>
                                        <div className="col-12">
                                            <Switch onChange={this.setCity('qrPayment')} checked={this.props.edit.qrPayment} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-12 col-form-label">Доставка до подъезда</label>
                                        <div className="col-12">
                                            <Switch onChange={this.setCity('deliveryToTheEntrance')} checked={this.props.edit.deliveryToTheEntrance} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className='form-group'>
                                        <label>Комментарий</label>
                                        <input
                                        type='text'
                                        className='form-control'
                                        autoComplete='false'
                                        placeholder='Комментарий'
                                        maxLength={30}
                                        defaultValue={this.props.edit.comment}
                                        onChange={this.setCity('comment')}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-12 col-form-label">{'Работает как кафе (можно посидеть)'}</label>
                                        <div className="col-12">
                                            <Switch onChange={this.setCity('cafe')} checked={this.props.edit.cafe} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-12 col-form-label">Есть действующая акция</label>
                                        <div className="col-12">
                                            <Switch onChange={this.setCity('promotion')} checked={this.props.edit.promotion} />
                                        </div>
                                    </div>
                                </div>
                                {this.props.edit.promotion && <div className="col-md-4">
                                    <div className='form-group'>
                                        <label>Описание акции</label>
                                        <input
                                        type='text'
                                        className='form-control'
                                        autoComplete='false'
                                        placeholder='Описание акции'
                                        defaultValue={this.props.edit.promotionDescription}
                                        onChange={this.setCity('promotionDescription')}
                                        />
                                    </div>
                                </div>}
                            </div>
                            {[roleId.admin].includes(this.props.user.role.id) && 
                            <>
                                <div className='online-pay_block'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label className="col-12 col-form-label">Отправлять заказ в Robovoice</label>
                                            <div className="col-12">
                                                <Switch 
                                                    onChange={this.setCity('isRobovoiceEnable')}
                                                    checked={this.props.edit.isRobovoiceEnable}
                                                />
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                                <div className="col-md-12">
                                            <label className="col-12 col-form-label">Отправлять заказ в Frontpad</label>
                                            <div className="col-12">
                                                <Switch 
                                                    onChange={this.setCity('isEnableFrontpadForPoint')}
                                                    checked={this.props.edit.isEnableFrontpadForPoint}
                                                />
                                            </div>
                                        </div>
                                <div className="row">                                    
                                    <div className="col-md-4">
                                        <div className="form-group row">
                                            <div className="col-12">
                                                <button
                                                    disabled={this.props.loading}
                                                    onClick={(e) => this.handleRemoveUserPoints(e)}
                                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.loadingRemoveUserPoint })}>
                                                    Сброс привязки пользователей
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            }
                            {[roleId.admin, roleId.operationDirector].includes(this.props.user.role.id) &&
                            <div className='online-pay_block'>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <Input
                                            label="Кол-во дней для блокировки изменений табеля"
                                            onChange={this.setCity('blockWageFund')}
                                            value={this.props.edit.blockWageFund || 3}
                                            placeholder="Блокировка изменения табеля дней"
                                        />
                                    </div>
                                </div>
                            </div>
                            }
                            {[roleId.admin].includes(this.props.user.role.id) &&
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <Input
                                            required={true}
                                            label="Координаты"
                                            onChange={this.setCity('coord')}
                                            value={this.props.edit.coord}
                                            placeholder="Координаты..."
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <YMaps
                                            style={{ padding: '25px ', marginTop: -30 }}
                                            query={{
                                                apikey: '71140458-f614-4101-ad58-f75c79f0f6fe'
                                            }}
                                            >
                                            <Map
                                                
                                                width="100%"
                                                defaultState={{ center: this.props.edit.coord.split(','), zoom: 15, controls: [] }}
                                            >
                                                <Placemark geometry={this.props.edit.coord.split(',')} />
                                                <SearchControl instanceRef={ref => this.map = ref} onResultShow={this.onResultShow} options={{ float: 'right' }}/>
                                            </Map>
                                        </YMaps>
                                    </div>
                            </div>
                            </>
                            }
                        </div>
                        <ErrorContainer field="editFilial" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidFilial() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.editFilialLoader })}>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    const goodsSelector = state => state.good.list;
    const categoriesSelector = state => state.good.categories;

    const normalizeGoodsSelector = createSelector(
        goodsSelector,
        categoriesSelector,
        (goods, categories) => {
            const resultCategories = categories.reduce((data, item) => {
                data[item.id] = item.title;
                return data;
            }, {});

            const resultGoods = goods.filter((good) => !good.isGroup).reduce((data, item) => {
                if (data[item.category.id]) {
                    data[item.category.id].push({ value: item.id, label: item.name });
                } else {
                    data[item.category.id] = [{ value: item.id, label: item.name }];
                }
                return data;
            }, {});
            
            const result = Object.keys(resultGoods).map(key => {
                return ({
                    label: resultCategories[key],
                    options: resultGoods[key],
                });
            }).filter(item => item.label);

            return result;
        }
    );

    return ({
        edit: state.handbook.filial.edit,
        detail: state.handbook.filial.detail,
        loading: state.loaders.filial,
        editFilialLoader: state.loaders.editFilial,
        cities: state.handbook.cities,
        kassaAccounts: state.yookassa.list,
        loadingGoods: state.loaders.goods || state.loaders.category,
        loadingRemoveUserPoint: state.loaders.removeUserPoint,
        goods: normalizeGoodsSelector(state),
        user: state.user.info
    });
}

const mapDispatchToProps = {
    fetchFilial: (id) => fetchFilial(id),
    setFilialEdit: (data) => setFilialEdit(data),
    fetchCities: () => fetchCities(true),
    fetchKassaAccounts: () => fetchKassaAccounts(true),
    updateFilial: (id, data) => updateFilial(id, data),
    fetchGoods: () => fetchGoods(),
    fetchCategories: () => fetchCategories(),
    removeUserPoint: (id) => removeUserPoint(id),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditFilial);